import { Observable } from 'rxjs'
import { interval as intervalObs } from 'rxjs'
import { first as firstObs, map as mapObs, skipWhile, toPromise } from 'rxjs/operators'

// import { _.isFunction } from '../util/minilo'
import mergeDescriptors from '../../utils/merge-descriptors'
import cmp from '../compilers/v-compiler'
import useMapCmp from '../compilers/_map_obs'

const props = {
  attributions: [String, Array],
  logo: String,
  projection: String,
  wrapX: {
    type: Boolean,
    default: true,
  },
}

const methods = {
  /**
   * @return {ol.source.Source|Promise<ol.source.Source>}
   * @protected
   */
  createOlObject () {
    // console.log("createOlObject source.js")
    return this.createSource()
  },
  /**
   * @return {ol.source.Source|Promise<ol.source.Source>}
   * @protected
   * @abstract
   */
  createSource () {
    throw new Error('Not implemented method')
  },
  /**
   * @return {Promise}
   * @protected
   */
  init () {
    // console.log("Init source.js")
    return cmp.methods.init.call(this)
  },
  /**
   * @return {void|Promise<void>}
   * @protected
   */
  deinit () {
    return cmp.methods.deinit.call(this)
  },
  /**
   * @return {Object}
   * @protected
   */
  getServices () {
    const vm = this

    return mergeDescriptors(
      cmp.methods.getServices.call(this),
      {
        get source () { return vm.$source },
      }
    )
  },
  getFeaturesAtCoordinate (coordinate) {
    if(this.type == 'vector'){
      // get data locally
    } else {
      return this.$source.getGetFeatureInfoUrl(coordinate,this.$map.getView().getResolution(),this.projection,{"INFO_FORMAT":"application/json","FEATURE_COUNT":"20"});
    }
  },
  waitSourceReady(){
    return intervalObs(100)
      .pipe(skipWhile(() => !this.$source.getState() == 'ready'))
      .pipe(firstObs())
      .pipe(mapObs(() => this))
      .toPromise(Promise)
  },
  /**
   * @return {void}
   * @protected
   */
  mount () {
    // Maybe this will capture the OL Source State
    var vm = this

    this.$sources && this.$sources.addSource(this)
    this.$sourceContainer && this.$sourceContainer.setSource(this)

    this.waitSourceReady().then(() => {
      this.$sources.increment(this)
      this.$parent.$emit('source-initialized', this)
    })

    // this.subscribeAll()

  },
  /**
   * @return {void}
   * @protected
   */
  unmount () {
    // this.unsubscribeAll()
    this.$sourceContainer && this.$sourceContainer.setSource(undefined)
  },
  /**
   * @return {Promise<void>}
   */
  refresh () {
    if (this.$source && !_.isFunction(this.$source.clear)) {
      return cmp.methods.refresh.call(this)
    }

    return new Promise(resolve => {
      let done = () => {
        ++this.rev
        resolve()
      }
      if (this.$source) {
        this.$source.once('change', done)
        this.$source.clear()
      } else {
        done()
      }
    })
  },
}

const watch = {
  attributions (value) {
    this.$source && this.$source.setAttributions(value)
  },
}

export default {
  mixins: [cmp, useMapCmp],
  props,
  methods,
  watch,
  stubVNode: {
    empty () {
      // return this.$options.name
    },
  },
  created () {
    // console.log("Created source.js")
    Object.defineProperties(this, {
      /**
       * @type {ol.source.Source|undefined}
       */
      $source: {
        enumerable: true,
        get: () => this.$olObject,
      },
      $map: {
        enumerable: true,
        get: () => this.$services && this.$services.map,
      },
      $view: {
        enumerable: true,
        get: () => this.$services && this.$services.view,
      },
      $sourceContainer: {
        enumerable: true,
        get: () => this.$services && this.$services.sourceContainer,
      },
      $sources: {
        enumerable: true,
        get: () => this.$services && this.$services.sources,
      },
    })

  },
}



// WEBPACK FOOTER //
// ./resources/js/map/MapComponents/mixins/layers/source.js